import { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import styles from './RegionSelector.module.scss'
import { Region } from 'application/types/Region'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { setRegion } from 'features/region/regionSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



type RegionSelectorProps = {
    onRegionSelect: (region: Region) => void;
};

const RegionSelector: React.FC<RegionSelectorProps> = ({ onRegionSelect }) => {
    const { urlRegion } = useParams();
    const [showDropdown, setShowDropdown] = useState(false);
    const [regionName, setRegionName] = useState("")
    const dispatch = useDispatch<AppDispatch>();
    const region = useSelector((state: RootState) => state.region.region);
    const regionList = useSelector((state: RootState) => state.region.regionList);
    const navigate = useNavigate();
    const { t } = useTranslation();


    useEffect(() => {
        if (regionList.length > 0) {
            const regionFromList = regionList.find(f => f.regionCode === region);
            const urlRegionFromList = regionList.find(f => f.regionCode.toLowerCase() === urlRegion?.toLowerCase());
            const matchedRegion = urlRegionFromList || regionFromList || regionList[0];
            dispatch(setRegion(matchedRegion.regionCode));
            setRegionName(matchedRegion.regionName);
        }
    }, [regionList, region, urlRegion, dispatch]);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleSelect = (region: Region) => {
        onRegionSelect(region)
        setRegionName(region.regionName);
        setShowDropdown(false);
        navigate(`/${region.regionCode}`);
    };

    return (
        <div className={`position-relative`}>
            <div className="d-flex align-items-center justify-content-center w-100">
                <span onClick={toggleDropdown} className={`${styles.helpText} me-2`}   >
                    {t("NOT_IN_REGION", { region: regionName })
                    }{" "}
                    {t("CHANGE_REGION")}
                </span>
                <img src={process.env.PUBLIC_URL + `/flags/${region}.png`} alt={regionName} className={`${styles.flagIcon} ms-2 mt-1`} />
            </div>
            {showDropdown && (
                <>
                    <div className='position-fixed start-0 top-0 end-0 bottom-0' onClick={() => setShowDropdown(false)}></div>
                    <div className={`${styles.regionSelector} border bg-white p-2 shadow position-absolute`}>
                        {regionList.map((region) => (
                            <div
                                key={region.regionCode}
                                className={`${styles.regionNames} d-flex align-items-center py-1 px-2 hover-bg`}
                                role="button"
                                onClick={() => handleSelect(region)}
                            >
                                <Image
                                    src={process.env.PUBLIC_URL + `/flags/${region.regionCode}.png`}
                                    alt={region.regionName}
                                    width={24}
                                    height={16}
                                    className="me-2"
                                />
                                {region.regionName}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default RegionSelector;